export default {
  '系统默认样式': '系統默認樣式',
  '重打印': '重列印',
  '店铺编号print': '店鋪編號',
  '单据日期': '單據日期',
  '核销单号print': '核銷單號',
  '定金单号': '定金單號',
  '小票号print': '小票號',
  '操作时间print': '操作時間',
  '收银员print': '收銀員',
  '营业员print': '營業員',
  '店铺电话print': '店鋪電話',
  '店铺手机print': '店鋪手機',
  '会员编号print': '會員編號',
  '会员姓名print': '會員姓名',
  '会员等级print': '會員等級',
  '销售备注print': '銷售備註',
  '店铺地址print': '店鋪地址',
  '已中所有促销': '已中所有促銷',
  '已中整单促销': '已中整單促銷',
  '总额print': '總額',
  '优惠print': '優惠',
  '应付print': '應付',
  '找零': '找零',
  '积分': '積分',
  '支付流水号': '支付流水號',
  '获得积分print': '獲得積分',
  '积分余额print': '積分余額',
  '储值余额print': '儲值余額',
  '代用券券号': '代用券券號',
  '顾客签名': '顧客簽名',
  '该单所有的促销': '該單所有的促銷',
  '促销描述': '促銷描述',
  '货品print': '貨品',
  '吊牌价print': '吊牌價',
  '会员价': '會員價',
  '折后价print': '折後價',
  '零售折扣/折后价': '零售折扣/折后价',
  '零售价print': '零售价',
  '零售折扣print': '零售折扣',
  '折扣/折后价': '折扣/折後價',
  '折扣print': '折扣',
  '数量print': '數量',
  '金额print': '金額',
  '合计print': '合計',
  '会员print': '會員',
  '顾客联': '顧客聯',
  '店铺联': '店鋪聯',
  '税额/金额': '稅額/金額',
  '税额': '稅額',
  '代用券': '代用券',
  '不限': '不限',
  '满-金额': '满',
  '可用': '可用',
  '店铺': '店鋪',
  '番禺区城店': '番禺區城店',
  '广州市番禺区天安节能科技园15号楼': '廣州市番禺區天安節能科技園15號樓',
  '买满送优惠券': '買滿送優惠券',
  '买满打折(按货品)': '買滿打折(按貨品)',
  '买满立减(按单)': '買滿立減(按單)',
  '王晓': '王曉',
  '快递费': '快遞費',
  '金属感香槟灰': '金屬感香檳灰',
  '长袖上衣': '長袖上衣',
  'FS OTH 男装运动套头衫': 'FS OTH 男裝運動套頭衫',
  '现金支付': '現金支付',
  '高级会员': '高級會員',
  '方某某': '方某某',
  '张三': '張三',
  '日期': '日期'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-hant/preview.js